/* AUTH */
export const LOGIN_USER = "LOGIN_USER";
export const SET_PENDUDUK = "SET_PENDUDUK";
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGIN_USER_FAILED = "LOGIN_USER_FAILED";
export const REGISTER_USER = "REGISTER_USER";
export const REGISTER_USER_SUCCESS = "REGISTER_USER_SUCCESS";
export const REGISTER_USER_FAILED = "REGISTER_USER_FAILED";
export const LOGOUT_USER = "LOGOUT_USER";
export const FORGET_PASSWORD = "FORGET_PASSWORD";
export const FORGET_PASSWORD_SUCCESS = "FORGET_PASSWORD_SUCCESS";
export const FORGET_PASSWORD_FAILED = "FORGET_PASSWORD_FAILED";
export const GET_ME = "GET_ME";
export const SET_USER = "SET_USER";
export const SET_DESA = "SET_DESA";
export const ACCESS_BLOCKED = "ACCESS_BLOCKED";
export const HANDLE_ERROR = "HANDLE_ERROR";
export const GET_ME_FAILED = "GET_ME_FAILED";
export const SET_SUMMARY_DATA = "SET_SUMMARY_DATA";
export const SET_LOADING = "SET_LOADING";
